import Axios from '../utils/axios-utils';

// create meter
export const createMeter = async (data, accountId) => {
    try {
        const response = await Axios.post(`/accounts/${accountId}/meters`, {
            meterTime: data.meterTime,
            vehicleId: data.vehicleId,
            type: data.type,
            value: data.value,
            note: data.note,
        });

        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Create Meter error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Create Meter failed" }
        };
    }
};

// get all Meter
export const getAllMeters = async (accountId, from, to) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/meters`, {
            params: { from, to }
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Meters error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Meters failed" }
        };
    }
};

// update Meter
export const updateMeter = async (accountId, meterId, data) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/meters/${meterId}`, data);
        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update Meter error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update Meter failed" }
        };
    }
};

// delete Meter
export const deleteMeter = async (accountId, meterId) => {
    try {
        const response = await Axios.delete(`/accounts/${accountId}/meters/${meterId}`);
        return {
            success: response.data.status === 'success',
            data: response.data,
            status: response.status
        };
    } catch (error) {
        console.log("Delete Meter error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Delete Meter failed" },
            status: error.response?.status || 500
        };
    }
};

// update Meter status
export const updateMeterStatus = async (accountId, fuelId, status) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/meters/${fuelId}/status`, {
            status,
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update Meter Status error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update Meter Status failed" }
        };
    }
};

// get all meter statuses
export const getAllMeterStatuses = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/meters/statuses`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Meter statuses error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Meter statuses failed" }
        };
    }
};


// get all meter types
export const getAllMeterTypes = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/meters/types`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Meter types error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Meter types failed" }
        };
    }
};